import React from 'react'

const Practices = () => {
  return (
    <div className="skills_content">
      <h3 className="skills_title"><i class='bx bx-check-shield'></i> Practices </h3>

      <div className="skills_list">
        <div className="skills_item"> REST APIs</div>
        <div className="skills_item"> Unit Tests</div>
        <div className="skills_item"> CI/CD</div>
        <div className="skills_item"> Scrum</div>
        <div className="skills_item"> Clean Code</div>
      </div>
    </div>
  )
}
export default Practices